import { useModal } from 'lib/modal'
import LeadModal from './LeadModal'

export default function useLeadModal() {
  return useModal(LeadModal)
}
